export const SIZE_OPTIONS = {
  xs: '20px',
  sm: '28px',
  md: '40px'
};
export const getSpinnerSize = (size = 'sm') => {
  return SIZE_OPTIONS[size];
};
export const getIconColor = use => {
  switch (use) {
    case 'danger':
      return 'fill-alert-default';
    case 'primary':
    case 'secondary':
      return 'fill-primary-default';
    case 'on-dark':
    case 'secondary-ghost':
      return 'fill-inverse-default-alt';
    case 'primary-white':
    case 'tertiary':
    case 'tertiary-light':
    case 'tertiary-extra-light':
      return 'icon-tertiary-default';
    case 'success':
      return 'fill-positive-default';
    case 'link':
    default:
      return 'icon-interactive-default';
  }
};
export const getIconSize = size => {
  switch (size) {
    case 'xs':
    case 'extra-small':
      return '500';
    case 'md':
    case 'medium':
      return '800';
    case 'sm':
    case 'small':
    default:
      return '700';
  }
};